function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as e, jsxs as s } from "react/jsx-runtime";
import { useTheme as h } from "../../hooks.js";
import { useIsInverseVariant as c } from "../../theme-variant-context.js";
import { vars as a } from "../../skins/skin-contract.css-mistica.js";
const m = (_param)=>{
    var { color: n , size: r = 24  } = _param, t = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const l = c(), o = n !== null && n !== void 0 ? n : l ? a.colors.inverse : a.colors.neutralHigh, { skinName: i  } = h();
    return i.match(/^blau/i) ? /* @__PURE__ */ e("svg", _object_spread_props(_object_spread({
        width: r,
        height: r,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, t), {
        children: /* @__PURE__ */ e("path", {
            fill: o,
            d: "M12 3.355c-4.606 0-8.645 4.04-8.645 8.645 0 4.606 4.04 8.645 8.645 8.645 4.605 0 8.645-4.04 8.645-8.645 0-4.605-4.04-8.645-8.645-8.645zM12 22C6.673 22 2 17.327 2 12S6.673 2 12 2s10 4.673 10 10-4.673 10-10 10zm.007-15.861a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4zm-.685 5.013h1.355v6.78h-1.355v-6.78z"
        })
    })) : i.match(/^o2/i) ? /* @__PURE__ */ s("svg", _object_spread_props(_object_spread({
        width: r,
        height: r,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, t), {
        children: [
            /* @__PURE__ */ e("path", {
                fill: o,
                d: "M12 17.356a.718.718 0 01-.716-.716V9.856c0-.392.32-.716.716-.716.392 0 .716.32.716.716v6.784a.718.718 0 01-.716.716zm0-9.284a.892.892 0 100-1.784.892.892 0 000 1.784z"
            }),
            /* @__PURE__ */ e("path", {
                fill: o,
                d: "M2 12c0 5.5 4.5 10 10 10s10-4.5 10-10S17.5 2 12 2 2 6.5 2 12zm1.428 0c0-4.716 3.856-8.572 8.572-8.572 4.716 0 8.572 3.856 8.572 8.572 0 4.716-3.856 8.572-8.572 8.572-4.716 0-8.572-3.856-8.572-8.572z"
            })
        ]
    })) : /* @__PURE__ */ e("svg", _object_spread_props(_object_spread({
        width: r,
        height: r,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, t), {
        children: /* @__PURE__ */ e("path", {
            fill: o,
            d: "M23 12.034C23 1.833 14.714 1.031 12.504 1c-.335 0-.673 0-1.008.006C9.396 1.044 1 1.833 1 11.97c0 10.117 8.386 10.968 10.543 11.019.254.009.548.012.83.012h.21C14.788 22.981 23 22.224 23 12.034zm-1.374 0c0 8.584-6.333 9.567-9.056 9.592 0 0-.197 0-.197-.003-.273 0-.555-.004-.799-.01-2.767-.066-9.2-1.14-9.2-9.644 0-8.502 6.395-9.538 9.147-9.589.32-.006.642-.006.961-.003 2.752.038 9.144 1.058 9.144 9.657zm-9.62-2.77c.379 0 .689.307.689.689v7.15a.689.689 0 11-1.377 0v-7.15a.69.69 0 01.688-.689zM12.77 7.6a.73.73 0 00-.758-.708.74.74 0 00-.71.708.736.736 0 00.707.757h.054a.73.73 0 00.707-.757z"
        })
    }));
}, u = m;
export { u as default };
